export default {"src":"/_next/static/media/menu_01.3b0dba0c.svg","height":19,"width":27,"blurWidth":0,"blurHeight":0};